module.exports = __webpack_public_path__ + "static/media/four.31361fd5.svg";